<template>
  <div>
    <v-card v-if="cheque" class="rounded-lg white">
      <v-card-title class="secondary white--text">
        {{ title }}
        <v-spacer></v-spacer>
        <v-tooltip top color="#019EF6">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              small
              v-bind="attrs"
              v-on="on"
              class="export-btn mr-4 mt-1 mt-md-0 pa-4"
              @click="exportCheque('html')"
              icon
            >
              <v-img max-height="25" max-width="25" src="/img/icons/print_icon.svg"></v-img>
            </v-btn>
          </template>
          چاپ رسید چک
        </v-tooltip>
        <v-tooltip top color="#019EF6">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              small
              class="secondary--text export-btn mt-2 mt-sm-0 mr-md-2"
              @click="exportCheque('pdf')"
              icon
            >
              <v-img max-height="25" max-width="25" src="/img/icons/pdf.svg"></v-img>
            </v-btn>
          </template>
          خروجی PDF رسید چک
        </v-tooltip>
      </v-card-title>
      <v-card-text class="">
        <v-row>
          <v-col cols="12" md="4">
            <v-simple-table dense class="detail-table">
              <tbody>
                <tr>
                  <th bgcolor="red" v-if="!isPaidCheque">دریافت از :</th>
                  <th v-else>پرداخت به :</th>
                  <td>{{ cheque.account && cheque.account.title }}</td>
                </tr>
                <tr v-if="cheque.floatAccount">
                  <th>حساب شناور:</th>
                  <td>{{ cheque.floatAccount.name }}</td>
                </tr>
                <tr>
                  <th>مبلغ:</th>
                  <td>{{ cheque.value | toMoney }}</td>
                </tr>
                <tr>
                  <th>تاریخ سررسید:</th>
                  <td>{{ cheque.due }}</td>
                </tr>
                <tr>
                  <th v-if="!isPaidCheque">شماره چک</th>
                  <th v-else>سریال چک</th>
                  <td>{{ cheque.serial }}</td>
                </tr>

                <tr>
                  <th>نام بانک:</th>
                  <td v-if="!isPaidCheque">{{ cheque.bankName }}</td>
                  <td v-else>{{ cheque.chequebook.account.name }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
          <v-col cols="12" md="4">
            <v-simple-table dense class="detail-table">
              <tbody>
                <tr>
                  <th>شماره صیادی :</th>
                  <td>{{ cheque.iban }}</td>
                </tr>
                <tr>
                  <th>شماره حساب بانک:</th>
                  <td v-if="!isPaidCheque">{{ cheque.accountNumber }}</td>
                  <td v-else>{{ cheque.chequebook.account.account_number }}</td>
                </tr>
                <tr>
                  <th v-if="isPaidCheque">تاریخ پرداخت:</th>
                  <th v-else>تاریخ دریافت:</th>
                  <td>{{ cheque.date }}</td>
                </tr>

                <tr v-if="isPaidCheque">
                  <th>شماره سری</th>
                  <td>{{ cheque.chequebook.serial }}</td>
                </tr>
                <tr>
                  <th>نام شعبه:</th>
                  <td v-if="!isPaidCheque">{{ cheque.branchName }}</td>
                  <td v-else>{{ cheque.chequebook.account.branch_name }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
          <v-col cols="12" md="4">
            <v-simple-table dense class="detail-table">
              <tbody>
                <tr v-if="!isPaidCheque">
                  <th>نوع :</th>
                  <td>{{ cheque.owner_type_display }}</td>
                </tr>
                <tr>
                  <th>وضعیت:</th>
                  <td>{{ cheque.status | chequeStatuses }}</td>
                </tr>
                <tr style="height: 70px">
                  <th>شرح :</th>
                  <td>{{ cheque.explanation }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="canSubmitCheque && isPaidCheque && cheque.status == 'blank'"
          class="error white--text rounded-lg"
          depressed
          @click="showRevokeDialog = true"
          >باطل کردن
        </v-btn>
        <v-btn
          v-if="canSubmitCheque"
          depressed
          class="success rounded-lg white--text w-100px"
          :to="{
            name: 'ChequeForm',
            params: { type: 'c', isPaid: cheque.is_paid, id: id },
          }"
          >ثبت
        </v-btn>
        <v-btn
          depressed
          v-else-if="canEditCheque"
          class="rounded-lg warning w-100px"
          :to="{
            name: 'ChequeForm',
            params: { type: cheque.type, isPaid: cheque.is_paid, id: id },
          }"
          >ویرایش
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-card v-if="cheque" class="mt-3 rounded-lg white">
      <v-card-title class="secondary white--text">
        تغییر وضعیت ها
        <v-spacer></v-spacer>
      </v-card-title>

      <v-card-text>
        <v-simple-table class="rounded-lg status-changes-table">
          <thead>
            <tr>
              <th class="text-center" width="20px">ردیف</th>
              <th class="text-center">تغییر از وضعیت</th>
              <th class="text-center">به وضعیت</th>
              <th class="text-center">تاریخ</th>
              <th class="text-center">حساب بدهکار</th>
              <th class="text-center">حساب بستانکار</th>
              <th class="text-center">توضیحات</th>
              <th class="text-center"></th>
              <th class="text-center"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(sc, i) in statusChanges" :key="i">
              <td class="text-center">{{ i + 1 }}</td>
              <td class="text-center">{{ sc.fromStatus | chequeStatuses }}</td>
              <td class="text-center">{{ sc.toStatus | chequeStatuses }}</td>
              <td class="text-center">{{ sc.date }}</td>
              <td class="text-center">{{ (sc.bedAccount && sc.bedAccount.name) || "-" }}</td>
              <td class="text-center">{{ (sc.besAccount && sc.besAccount.name) || "-" }}</td>
              <td class="text-center">{{ sc.explanation }}</td>
              <td class="text-center">
                <open-sanad-btn
                  disabled
                  v-if="sc.sanad"
                  :disabled="sc.financial_year != financialYear.id"
                  :sanad="sc.sanad"
                />
              </td>
              <td class="text-center">
                <v-btn
                  v-if="
                    i == statusChanges.length - 1 &&
                    (isPaidCheque || i != 0) &&
                    !financialYear.is_closed &&
                    sc.financial_year == financialYear.id
                  "
                  @click.prevent="deleteStatusChange(sc)"
                  class="red--text"
                  icon
                >
                  <v-img src="/img/icons/delete.svg" max-height="25" max-width="25"></v-img>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          depressed
          @click="showChangeChequeStatusDialog"
          :disabled="!canChangeStatus"
          class="accent white--text mr-1 rounded-lg"
          >تغییر وضعیت
        </v-btn>
      </v-card-actions>

      <change-cheque-status :cheque="cheque" @statusChange="getCheque(id)" ref="changeChequeStatusComponent" />
    </v-card>

    <v-dialog v-model="showRevokeDialog" max-width="300px" transition="dialog-transition">
      <v-card>
        <v-card-title class="mb-2 error--text">باطل کردن</v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <date label=" * تاریخ" v-model="revokeData.date" :default="true" />
            </v-col>
            <v-col cols="12">
              <v-textarea class="rounded-lg" label="* توضیحات" v-model="revokeData.explanation" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="revokeCheque" depressed class="error rounded-lg white--text w-100px">ابطال</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <m-datatable
      v-show="false"
      :headers="headers"
      :exportUrl="exportUrl"
      :filters.sync="export_filter"
      ref="exportTable"
    >
    </m-datatable>
  </div>
</template>

<script>
import money from "@/components/mcomponents/cleave/Money";
import date from "@/components/mcomponents/cleave/Date";
import changeChequeStatus from "./ChangeChequeStatus";
import ChequeMixin from "./mixin.js";
import OpenSanadBtn from "@/components/btns/OpenSanadBtn";

export default {
  components: { money, date, changeChequeStatus, OpenSanadBtn },
  mixins: [ChequeMixin],
  props: {
    id: {
      required: true,
    },
  },
  data() {
    return {
      cheque: null,
      showRevokeDialog: false,
      revokeData: {},
      exportUrl: "reports/lists/chequeDetail/",
      export_filter: {},
    };
  },
  computed: {
    headers() {
      return [];
    },
    title() {
      if (this.cheque && this.isPaidCheque) {
        return "جزئیات " + this.getTypeName(this.cheque.type) + " پرداختنی";
      } else if (this.cheque && !this.isPaidCheque) {
        return "جزئیات " + this.getTypeName(this.cheque.type) + " دریافتنی";
      } else {
        return "";
      }
    },
    isPaidCheque() {
      return this.cheque && this.cheque.is_paid;
    },
    statusChanges() {
      if (this.cheque) return this.cheque.statusChanges;
      return [];
    },
    canSubmitCheque() {
      return this.statusChanges.length == 0 && !this.financialYear.is_closed;
    },
    canEditCheque() {
      return this.statusChanges.length <= 1 && !this.financialYear.is_closed && this.cheque.status != "revoked";
    },
    canChangeStatus() {
      if (this.financialYear.is_closed) return false;

      let s = this.cheque.status;
      if (["passed", "cashed", "revoked", "transferred", "blank"].includes(s)) return false;
      return true;
    },
  },
  created() {
    this.getChequeMeta();
    this.getCheque(this.id);
  },
  methods: {
    exportCheque(type) {
      this.export_filter = { id: this.cheque.id };
      this.$refs.exportTable.exportTo(type);
    },
    revokeCheque() {
      this.request({
        url: this.endpoint(`cheques/changeStatus/revokeBlankPaidCheque/`),
        method: "post",
        data: {
          ...this.revokeData,
          cheque: this.id,
        },
        success: (data) => {
          this.getCheque(this.id);
          this.successNotify();
          this.showRevokeDialog = false;
        },
      });
    },
    showChangeChequeStatusDialog() {
      this.$refs.changeChequeStatusComponent.dialog = true;
    },
    payer(cheque) {
      let res = cheque.account.title;
      if (cheque.floatAccount) res += cheque.floatAccount.name;
      return res;
    },
    deleteStatusChange(sc) {
      this.request({
        url: this.endpoint(`cheques/statusChange/${sc.id}/`),
        method: "delete",
        success: (data) => {
          this.getCheque(this.id);
          this.successNotify();
        },
      });
    },
    setItem(cheque) {
      this.$router.push({
        name: "ChequeDetail",
        params: {
          id: cheque.id,
        },
      });
      this.cheque = cheque;
    },
  },
  filters: {
    chequeStatuses(val) {
      switch (val) {
        case "blank":
          return "سفید";
        case "notPassed":
          return "پاس نشده";
        case "inFlow":
          return "در جریان وصول";
        case "passed":
          return "پاس شده";
        case "bounced":
          return "برگشتی";
        case "cashed":
          return "نقدی";
        case "revoked":
          return "باطل شده";
        case "transferred":
          return "انتقالی";
        case "guarantee":
          return "ضمانتی";
        case "extended":
          return "تمدید شده";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.jumbotron {
  padding: 15px 10px;
}

.status-box {
  background-color: white;
  padding: 4px 8px;
  border-radius: 5px;
}

.detail-table {
  th {
    background-color: #dae3ed !important;
  }
  td {
    padding: 0px 8px;
  }

  tr {
    th {
      width: 110px;
    }
  }
}

.status-changes-table {
  th {
    background-color: #dae3ed !important;
  }
}
</style>
